<template>
  <img
    v-if="avatarUrl"
    :src="avatarUrl"
    :style="styleAttr"
    alt
  >
  <div
    v-else
    :style="styleAttr"
  >
    <account-icon />
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    size: {
      type: Number,
      required: false,
      default: 36,
    },
  },
  data() {
    return {
      avatarUrl: '',
    };
  },
  computed: {
    styleAttr() {
      return `width: ${this.size}px;`
        + `height: ${this.size}px;`
        + `font-size: ${this.size}px;`;
    },
  },
  watch: {
    user() { this.load(); },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      let user;

      if (this.user.id === undefined) {
        user = this.userData;
      } else {
        user = JSON.parse(JSON.stringify(this.user));
      }

      if (user.avatar_url) {
        this.avatarUrl = user.avatar_url;
      } else {
        this.avatarUrl = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  img,
  div {
    border-radius: 0.25rem;
    vertical-align: middle;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }

  div {
    display: inline-block;
    background-color: #fff;
  }

  .material-design-icon > .material-design-icon__svg {
    position: static;
    color: var(--gray-darker);
  }
</style>
